import { MutableRefObject, useRef, useState } from "react"
import { HxMapGroup } from "../../../Comps/HxMap/HxMapGroup"
import { HexMap } from "../../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../../Data/HexMap/HexMapModifier"
import { TransformTranslate } from "../../../Util/Transform/Transform"
import { All } from "../../../Util/Constants/Quantities"
import { IndexSelector } from "../../../Util/TonicSelector/IndexSelector"
import { produce } from "immer"
import { Key } from "../../../Data/HexMap/Key"
import { NoteButtons } from "../../../Comps/NoteButtons/NoteButtons"
import { ExerciseMessage } from "../Utils/Message/ExerciseMessage"
import { NotePlayer } from "../../../Sound/NotePlayer"
import { useNotePlayer } from "../../../Sound/SoundStore"
import { OutlineBox } from "../../../Comps/OutlineBox/OutlineBox"

export function NeighborNamer(){
    const changeTonic:MutableRefObject<boolean> = useRef(true)

    const tonicSelector:MutableRefObject<IndexSelector> = useRef(new IndexSelector(12,4))
    const getNextTonic = () => { return tonicSelector.current.getRandomPosition() }
    const tonic:MutableRefObject<number> = useRef(tonicSelector.current.getRandomPosition(true))

    const selectableKeys:number[] = [0,1,2,3,4,6,7,8,9,10,11]
    const keyIndexSelector:MutableRefObject<IndexSelector> = useRef(new IndexSelector(selectableKeys.length,4))
    const getNextSelectedKeyIndex = () => {
        const selectableKeyIndex:number = keyIndexSelector.current.getRandomPosition()
        return selectableKeys[selectableKeyIndex]
    }
    const selectedKeyIndex:MutableRefObject<number> = useRef(getNextSelectedKeyIndex())

    const getInitialMessage = () => {
        return 'Define the selected key.'
    }
    const [answerStatus, setAnswerStatus] = useState<null|boolean>(null)
    const [message, setMessage] = useState<string>(getInitialMessage())
    const setAnswer = (message:string, answerStatus:boolean|null) => {
        setMessage(message)
        setAnswerStatus(answerStatus)
    }
    const getHexMap = (i:number = 0) => {
        const params:HexMapBuilderParams = {rows:3, columns:4, tonic:tonic.current, radius:50}
        const map:HexMap = BuildHexMap(params)
        const mod:HexMapModifier = new HexMapModifier(map)
        mod.keys_setOpen([All], false)
        mod.keys_setDefined([All], false)
        mod.keys_setDefined([5], true)
        mod.keys_setHilited([5])
        mod.keys_setSelected([selectedKeyIndex.current])
        return map
    }
    const [map, setMap] = useState(getHexMap())
    const mod:MutableRefObject<HexMapModifier> = useRef(new HexMapModifier(map))
    const notePlayer:MutableRefObject<NotePlayer> = useRef(useNotePlayer())
    const nextQuestion = () => {
        if(changeTonic.current){
            tonic.current = tonicSelector.current.getRandomPosition()
        }
        selectedKeyIndex.current = getNextSelectedKeyIndex()
        setAnswer('Identify the selected key.', null)
        setMap(getHexMap())
    }
    const onCorrect = () => {
        setMap(produce((draft:HexMap)=>{
            mod.current.setDraft(draft)
            mod.current.keys_setHilited([selectedKeyIndex.current])
            mod.current.keys_setDefined([selectedKeyIndex.current], true)
        }))
        const msg:string = 'Correct.'
        setAnswer(msg, true) 
        setTimeout(nextQuestion, 1000)  
    }
    
    const onIncorrect = () => { 
        setAnswer('Incorrect. Try again.', false)
        setTimeout(()=>{setAnswer(getInitialMessage(), null)}, 1500) 
    }
    const onNoteButtonClick = (keyTonic:number) => {
        const key:Key = map.keys.flat()[selectedKeyIndex.current]
        if(keyTonic === key.params.tonic){
            notePlayer.current.playNote(keyTonic, true)
            onCorrect()
            return
        }
        notePlayer.current.playBuzzer()
        onIncorrect()
    } 
    return(
        <OutlineBox width={700}>
            <ExerciseMessage answerStatus={answerStatus} message={message} key={Date.now()}/>
            <svg width={500} height={350}>
                <g transform={TransformTranslate(250,150)}>
                    <HxMapGroup hexMap={map}/>
                </g>
            </svg>
            <NoteButtons key={'singleton'} onClick={onNoteButtonClick}/>
        </OutlineBox>
        
    )
}